<p-dialog header="Map Import Fields" [(visible)]="displayFieldMapping" [modal]="true" [responsive]="true"
    [style]="{width: '60vw'}" (onHide)="closeDialog()" styleClass="import-details-dialog">
    <div class="card">
        <div class="tab-wrapper">
            <div class="tab-rightmenu-wrapper">
                <label (click)="applyAutoMapping()" class="p-text-right pointer p-mr-2" style="color: var(--primary-color);">
                    <span class="pi pi-refresh"></span>
                    Auto Mapping
                </label>
                <ng-container>
                    <span>|</span>
                    <label (click)="unmapAllFields()" class="p-text-right pointer p-mr-2 p-ml-2" style="color: var(--primary-color);">
                        <span class="pi pi-refresh"></span>
                         Unmap
                    </label>
                </ng-container>
                <span>|</span>
                <label (click)="loadTemplateFields()" class="p-text-right pointer p-ml-2" style="color: var(--primary-color);">
                    <span class="pi pi-cog"></span>
                    Template Fields
                </label>
            </div>
            <p-tabView [(activeIndex)]="selectedTabIndex" class="custom-tablist custom-tablist-button tab-rightmenu" [scrollable]="true">
                <p-tabPanel header="All">
                    <ng-container *ngTemplateOutlet="importMapTemplate"></ng-container>
                </p-tabPanel>
                <p-tabPanel header="Mapped Columns({{mappedFieldsCount}})">
                    <ng-container *ngTemplateOutlet="importMapTemplate"></ng-container>
                </p-tabPanel>
                <p-tabPanel header="Unmapped Columns({{unMappedFieldsCount}})">
                    <ng-container *ngTemplateOutlet="importMapTemplate"></ng-container>
                </p-tabPanel>
                @if(requiredFields.length){
                <p-tabPanel header="Required Fields ({{requiredFields.length}})">
                    <div class="p-grid">
                        <div *ngIf="formSubmitted && unMappedRequiredFields>0" class="p-col-12">
                            <p class="p-invalid">Please map required fields to continue.</p>
                        </div>
                        <div class="p-col-12">
                            <p-table [value]="requiredFields">
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th>{{ selectedModule?.name }} Required Fields</th>
                                        <th>File Columns</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-field let-rowIndex="rowIndex">
                                    <tr>
                                        <td><strong [ngClass]="{'required-field': !field.fileHeader && formSubmitted}">{{field.labelName}} <span class="required-field">*</span></strong></td>
                                        <td class="action">
                                            <p-dropdown
                                                [options]="selectedFileHeadersList | importAvailableFilter:field:selectedFileHeaders"
                                                optionLabel="excelHeader"
                                                [filter]="true"
                                                filterPlaceholder="Search Columns..."
                                                placeholder="Select File Column"
                                                appendTo="body"
                                                [(ngModel)]="field.fileHeader"
                                                appendTo="body"
                                                [showClear]="true"
                                                (onChange)="onRequiredFieldCahnge($event,field)">
                                            </p-dropdown>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="10">
                                            <div class="p-text-center">There are no required fields.</div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </p-tabPanel>
                }

            </p-tabView>

            <ng-template #importMapTemplate>
                <div class="p-grid">
                    <div class="p-col-12">
                        <p-table [value]="selectedFileHeaders | importMapFilter:selectedTabIndex">
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th>File Columns</th>
                                    <th>{{ selectedModule?.name }} Fields</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-field let-rowIndex="rowIndex">
                                <tr>
                                    <td><strong>{{field.excelHeader}}</strong></td>
                                    <td class="action">
                                        <liono-treeSelect
                                            [options]="moduleColumns"
                                            [filter]="true"
                                            filterPlaceholder="Search Fields..."
                                            placeholder="Select {{ selectedModule?.name }} Field"
                                            appendTo="body"
                                            [(ngModel)]="field.moduleField"
                                            [scrollHeight]="'285px'"
                                            [showClear]="true"
                                            (onNodeSelect)="onFieldChange($event,field)">
                                        </liono-treeSelect>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="10">
                                        <div *ngIf="selectedTabIndex == 0" class="p-text-center">The file doesn't have any columns.</div>
                                        <div *ngIf="selectedTabIndex == 1" class="p-text-center">No columns have been mapped yet.</div>
                                        <div *ngIf="selectedTabIndex == 2" class="p-text-center">No columns remain to be mapped.</div>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="closeDialog()" label="Back" class="p-button-secondary"></button>
        <!-- <button pButton label="Next" [disabled]="mappedFieldsCount==0" (click)="viewSummery()"></button> -->
        <button pButton label="Next" (click)="viewSummery()"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Import Summary" [(visible)]="displaySummary" [style]="{width: '50vw'}" (onHide)="closeSummeryDialog()">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <div class="p-ml-3">
                    <strong>File Name:</strong> {{selectedFile?.name}}
                </div>
            </div>
            <div class="p-col-12">
                <div class="p-ml-3">
                    <strong>Module Name:</strong> {{selectedModule?.name}}
                </div>
            </div>
            <ng-container *ngIf="selectedChannel?.name">
                <div class="p-col-12">
                    <div  class="p-ml-3">
                        <strong>Channel Name:</strong> {{selectedChannel?.name}}
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="selectedWorkspace?.name">
                <div class="p-col-12">
                    <div  class="p-ml-3">
                        <strong>Workspace Name:</strong> {{selectedWorkspace?.name}}
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="selectedWorkbook?.name">
                <div class="p-col-12">
                    <div  class="p-ml-3">
                        <strong>Workbook Name:</strong> {{selectedWorkbook?.name}}
                    </div>
                </div>
            </ng-container>
        </div>

        <hr/>

        <div class="p-grid">
            <div class="p-col-6" *ngIf="([accountModuleId, leadModuleId, workSpaceModuleId].includes(this.selectedModule?.id) || selectedModule?.name=='Tracking') && this.selectedAction?.value!='add'">
                <div class="p-d-flex p-ai-center p-jc-between p-mb-2">
                    <label class="p-text-bold" for="refrenceColumn">Reference Column<span  style="color: red;"> *</span>
                    <i pTooltip="Select a field that exists in both your file and the system to match records for updating data"
                       tooltipPosition="right"
                       class="pi pi-info-circle p-text-primary p-ml-2"
                       [tooltipOptions]="{ showDelay: 50, hideDelay: 50, positionStyle: 'fixed', appendTo: 'body' }">
                    </i>
                    </label>
                </div>
                <p-dropdown
                    [options]="referenceColumnOptions"
                    [filter]="true"
                    filterPlaceholder="Search Reference Column..."
                    placeholder="Select Reference Column"
                    appendTo="body"
                    optionLabel="name"
                    [(ngModel)]="refrenceColumn"
                    (ngModelChange)="validateReferenceColumn($event)"
                    [scrollHeight]="'285px'"
                    [showClear]="true">
                </p-dropdown>
                <div *ngIf="referenceError" class="p-error p-mt-2 p-ml-2">{{ referenceError }}</div>
            </div>
            <div class="p-col-12">
                <p-table [value]="selectedFileHeaders">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>File Columns</th>
                            <th><span>{{ selectedModule?.name === 'Workspace' ? 'Workbook' : selectedModule?.name }} Fields</span>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-field>
                        <tr *ngIf="field.moduleField">
                            <td><strong>{{field.excelHeader}}</strong></td>
                            <td><strong>{{field.moduleField?.labelName}}</strong></td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="closeSummeryDialog()" label="Back" class="p-button-secondary"></button>
        <button type="button" pButton label="Import Data" *ngIf="selectedModule?.name!='Tracking'" (click)="importData()"></button>
        <button type="button" pButton label="Import Data" *ngIf="selectedModule?.name=='Tracking'" (click)="saveTrackingMappedData()"></button>
    </p-footer>
</p-dialog>

<app-shared-import-sample-modal *ngIf="displayTemplateFields"
    [displayImportSample]="displayTemplateFields"
    [selectedModule]="selectedModule"
    [sectionColumns]="templateSectionColumns"
    [loadFields]="true"
    (fieldsUpdated)="templateFieldsRefresh($event)"
    (dialogClosed)="closeTemplateFields()">
</app-shared-import-sample-modal>
